<button mat-raised-button color="primary" (click)="onClick()">
  <mat-icon>add</mat-icon>{{configuration.btnTitle}}
</button>
